;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('MakeGlobalPaymentController', MakeGlobalPaymentController)

  MakeGlobalPaymentController.$inject = [
    // Angular
    '$uibModalInstance',

    // Managers
    'InvoiceTemplateManager',
    'QuoteTemplateManager',
    'CreditNoteTemplateManager',
    'DefaultQuoteTemplateManager',
    'DefaultInvoiceTemplateManager',
    'DefaultCreditNoteTemplateManager',
    // Services
    'DatePickerService', 'PreferencesService',
    // Resolve
    'elements'

  ]

  function MakeGlobalPaymentController (
    // Angular
    $uibModalInstance,

    // Managers
    InvoiceTemplateManager,
    QuoteTemplateManager,
    CreditNoteTemplateManager,
    DefaultQuoteTemplateManager,
    DefaultInvoiceTemplateManager,
    DefaultCreditNoteTemplateManager,

    // Services
    DatePickerService, PreferencesService,

    // Resolve
    elements

  ) {
    var self = this
    self.$onInit = () => {
      _.extend(self, {
        options: [
          { key: 'cash', value: 'Liquide' },
          { key: 'wire_transfert', value: 'Virement' },
          { key: 'check', value: 'Chèque' },
          { key: 'direct-debit', value: 'Prélèvement' },
          { key: 'credit-card', value: 'Carte bancaire' },
          { key: 'gift-card', value: 'Bon cadeau' }
        ],
        elements: elements,
        payment: {},
        isFieldDisplayed: isFieldDisplayed,
        resetDate: resetDate,
        selectDate: selectDate
      })

      init()
    }
    function validate (payment) {
      $uibModalInstance.close(payment)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    function init () {
      self.globalAmount = setGlobalAmount(self.elements)
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        if (generalPrefs.settings.defaultPaymentType) {
          self.payment.type = generalPrefs.settings.defaultPaymentType
        }
      })
    }

    function isFieldDisplayed () {
      return (self.payment.type === 'wire_transfert' ||
        self.payment.type === 'direct-debit' ||
        self.payment.type === 'check' ||
        self.payment.type === 'credit-card'
      )
    }

    function resetDate () {
      self.payment.date = null
      self.paymentForm.$dirty = true
    }

    function selectDate () {
      DatePickerService.getRange(self.paymentForm.date).then(function (date) {
        self.payment.date = new Date(date)
        self.paymentForm.$dirty = true
      })
    }

    function setGlobalAmount (elements) {
      let amout = 0
      elements.forEach(elt => {
        amout += -(elt.balanceDue)
      })
      return amout
    }

    _.extend(self, {
      cancel: cancel,
      validate: validate
    })
  }
})(window.angular, window._)
